module.exports = __webpack_public_path__ + "static/media/Ball@1.5x.e8382fc1.svg";